import clsx from 'clsx'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { Link, createFileRoute } from '@tanstack/react-router'
import $type from '@tandem/ui/type.css'
import $table from '@tandem/ui/table.css'
import Spinner from '@tandem/ui/Spinner'
import TrashIcon from '@tandem/ui/icons/trash.svg?react'
import { useTRPC } from '@/trpc'

export const Route = createFileRoute('/catalog/import/')({
  component: ImportListPage,
})

function ImportListPage() {
  let trpc = useTRPC()
  let queryClient = useQueryClient()
  let { data: imports, isFetching } = useQuery(trpc.catalog.import.list.queryOptions())
  let deleteImport = useMutation({
    ...trpc.catalog.import.delete.mutationOptions(),
    onSuccess: () => queryClient.invalidateQueries(trpc.catalog.import.list.queryFilter()),
  })

  return (
    <div>
      <div class={clsx($type.breadcrumb, $type.small)}>
        <a href='/catalog' class={$type.underline}>
          Каталог
        </a>
        <span>/</span>
        <b>Импорт</b>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '0.5em' }}>
        <h2>Импорт данных</h2>
        <Link to='/catalog/import/add'>
          <button class='secondary'>Добавить выгрузку</button>
        </Link>
      </div>

      {imports && imports.length > 0 ? (
        <table class={clsx($table.table)} style={{ marginTop: '1em' }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Файл</th>
              <th>Дата загрузки</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {imports.map((imp) => (
              <tr key={imp.id}>
                <td>
                  <Link to='/catalog/import/$id' params={{ id: String(imp.id) }} class={$type.underline}>
                    {imp.id}
                  </Link>
                </td>
                <td>{imp.original_filename || '—'}</td>
                <td>{new Date(imp.created_at).toLocaleString('ru')}</td>
                <td>
                  <button
                    class={clsx('plain', $type.muted)}
                    disabled={deleteImport.isPending}
                    onClick={() => {
                      if (confirm('Удалить выгрузку?')) deleteImport.mutate({ id: imp.id })
                    }}
                  >
                    {deleteImport.isPending && deleteImport.variables?.id === imp.id
                      ? <Spinner />
                      : <TrashIcon />}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p class={$type.muted} style={{ marginTop: '1em' }}>
          {isFetching ? <Spinner /> : 'Нет загруженных выгрузок'}
        </p>
      )}
    </div>
  )
}
